export default __webpack_public_path__ + "static/media/icon-facebook.a2a24200.svg";